import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { DomSanitizer } from '@angular/platform-browser';
import { environment } from 'src/environments/environment';

@Component({
  selector: 'app-achieve-program-data',
  templateUrl: './achieve-program-data.component.html',
  styleUrls: ['./achieve-program-data.component.scss']
})
export class AchieveProgramDataComponent implements OnInit {
  programId: any;
  url: any;

  constructor(private route: ActivatedRoute,
    private sanitizer: DomSanitizer) { }

  ngOnInit(): void {
    const programId = this.route.snapshot.paramMap.get('programId');
    const userId = this.route.snapshot.paramMap.get('userId');
    this.url = this.sanitizer.bypassSecurityTrustResourceUrl(`${environment.achieveWebUrl}/program-status/${programId}/${userId}`);
    console.log('this.url', this.url);
  }

}
